import { RouteTab } from 'custom_hooks/data_hooks/data_source/useRouteTabs';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import {
    backgroundColor,
    inputBorder,
    inputBorderFocused,
    link,
    primaryText,
} from 'styles/theme';

const RouteButtonTabsContainer = styled.div<{ $columns: number }>`
    display: grid;
    grid-template-columns: repeat(${(props) => props.$columns}, 1fr);
    overflow-x: auto;
`;

export const ButtonNavLink = styled(NavLink)<{ disabled: boolean }>`
    display: flex;
    justify-content: center;
    padding: 1rem 2rem;
    align-items: center;
    box-sizing: border-box;
    text-align: center;
    white-space: nowrap;
    margin: 0;
    border: solid 0.1rem ${inputBorder};
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    background-color: ${backgroundColor};
    color: ${primaryText};
    font-weight: 500;

    &:hover {
        border-color: ${inputBorderFocused};
    }

    &,
    &:visited,
    &:active {
        text-decoration: none;
        color: ${primaryText};
    }

    &[aria-current] {
        color: var(--text-on-color);
        background: ${link};
    }

    & + & {
        margin-left: 0.5rem;
    }
`;

export type RouteButtonTabsProps = Readonly<{
    routeTabs: RouteTab[];
    className?: string;
}>;

/**
 * Component for rendering route tabs (styled like radio buttons).
 */
export function RouteButtonTabs({ routeTabs, className }: RouteButtonTabsProps) {
    return (
        <RouteButtonTabsContainer $columns={routeTabs.length} className={className}>
            {routeTabs.map((tab) => (
                <ButtonNavLink
                    key={tab.id}
                    disabled={tab.disabled ?? false}
                    to={tab.url}
                    aria-label={tab.ariaLabel}
                    onClick={tab.disabled ? (event) => event.preventDefault() : undefined}
                >
                    {tab.icon && <div className="mr-10">{tab.icon}</div>}
                    <div>{tab.label}</div>
                </ButtonNavLink>
            ))}
        </RouteButtonTabsContainer>
    );
}
